<template>
  <div>
    <v-row justify="center">
      <v-dialog
        persistent
        v-model="show"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click.stop="show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ WindowLable }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container class="mt-5">
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1">
                  My New Project
                  <span v-if="tabOne" small class="red--text">{{
                    tabOneMessage
                  }}</span>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2">
                  <div v-if="projectData.analysisLevel == 'substation'">
                    Substation Profile
                  </div>
                  <div v-if="projectData.analysisLevel == 'feeder'">
                    Feeder Profile
                  </div>
                  <div v-if="projectData.analysisLevel == 'dt'">DT Profile</div>
                  <div
                    v-if="
                      projectData.analysisLevel !== 'dt' &&
                      projectData.analysisLevel !== 'feeder' &&
                      projectData.analysisLevel !== 'substation'
                    "
                  >
                    Profile
                  </div>
                  <span v-if="tabTwo" small class="red--text">{{
                    tabTwoMessage
                  }}</span>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 3" step="3">
                  Technology
                  <span v-if="tabThree" small class="red--text">{{
                    tabThreeMessage
                  }}</span>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 4" step="4">
                  VODER
                  <span v-if="tabFour" small class="red--text">{{
                    tabFourMessage
                  }}</span>
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-form class="px-3" ref="formProject" @submit.prevent="submit">
                  <v-stepper-content step="1">
                    <v-card width="500" class="mx-auto mt-9" flat>
                      <v-card-text>
                        <v-row mx-10>
                          <v-col>
                            <v-select
                              v-model="projectData.analysisLevel"
                              :items="analysisLevels"
                              item-text="title"
                              item-value="shortName"
                              label="Analysis Level"
                              @change="onChangeAnalysisLevel()"
                              :disabled="isAnalysisLevelReadOnly"
                            />
                          </v-col>
                          <v-col>
                            <v-icon
                              v-if="isEditable"
                              @click="showConfirmBox('Analysis')"
                              >mdi-close-circle-outline</v-icon
                            >
                          </v-col>
                        </v-row>
                        <v-row mx-10>
                          <v-col>
                            <v-select
                              v-model="projectData.technologyType"
                              :items="technologyTypes"
                              item-text="title"
                              item-value="shortName"
                              label="Technology"
                              :disabled="isTechnologyReadOnly"
                            />
                          </v-col>
                          <v-col>
                            <v-icon
                              v-if="isEditable"
                              @click="showConfirmBox('Technology')"
                              >mdi-close-circle-outline</v-icon
                            >
                          </v-col>
                        </v-row>
                        <!-- :disabled="isProjectTitleReadOnly" -->
                        <v-text-field
                          v-model="projectData.title"
                          :rules="inputRules"
                        >
                          <template v-slot:label>
                            Project Name
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>
                      </v-card-text>
                    </v-card>
                    <v-card-actions class="justify-center">
                      <v-btn outlined color="primary" @click="tabOne">
                        <template
                          v-if="
                            oldProjectTitle !== projectData.title ||
                            oldProjectTechnologyType !==
                              projectData.technologyType
                          "
                        >
                          Save & Next
                        </template>
                        <template
                          v-if="
                            oldProjectTitle === projectData.title &&
                            oldProjectTechnologyType ===
                              projectData.technologyType
                          "
                        >
                          Next
                        </template>
                      </v-btn>
                    </v-card-actions>
                  </v-stepper-content>
                </v-form>

                <v-stepper-content step="2">
                  <v-card width="600" class="mx-auto mt-9" flat>
                    <v-card-text>
                      <v-card flat outlined class="mb-10">
                        <v-card-title>
                          <div v-if="projectData.analysisLevel == 'substation'">
                            Substation Profile
                            <Tooltips :Tooltip="substationProfileTooltip" />
                          </div>
                          <div v-if="projectData.analysisLevel == 'feeder'">
                            Feeder Load Profile
                            <Tooltips :Tooltip="htLoadProfileTooltip" />
                          </div>
                          <div v-if="projectData.analysisLevel == 'dt'">
                            DT Profile
                            <Tooltips :Tooltip="dtLoadProfileTooltip" />
                          </div>
                          <v-spacer></v-spacer>
                          <v-icon
                            v-if="isEditable"
                            @click="showConfirmBox('LoadProfile')"
                          >
                            mdi-close-circle-outline</v-icon
                          >
                        </v-card-title>
                        <div class="mx-10">
                          <v-radio-group
                            v-model="profileSelection"
                            @change="onProfileSelectionChange()"
                            :disabled="isLoadProfileReadOnly"
                          >
                            <v-radio
                              label="Select an existing profile"
                              color="primary"
                              value="existing_profile"
                            ></v-radio>
                            <v-radio
                              label="Create a new profile"
                              color="primary"
                              value="new_profile"
                            ></v-radio>
                          </v-radio-group>

                          <v-form
                            class="px-3"
                            ref="formProfile"
                            @submit.prevent="submit"
                          >
                            <v-row v-if="isExistingProfileSelection">
                              <v-col>
                            <v-select
                              
                              v-model="projectData.loadProfileId"
                              :items="dbFileEntity"
                              item-text="title"
                              item-value="_id"
                              label="Select Existing Profile"
                              @change="onChangeExistingProfile()"
                              :disabled="isLoadProfileReadOnly"
                            />
                              </v-col>
                              <v-col>                                
                                    <v-text-field
                                      label="Year"
                                      v-model="projectData.loadProfileYear"
                                      :disabled="isLoadProfileReadOnly"
                                    ></v-text-field>
                                  </v-col>
                            </v-row>

                            <v-text-field
                              v-if="!projectData.loadProfileId"
                              v-model="projectData.loadProfileTitle"
                              :rules="inputRules"
                              :disabled="isLoadProfileReadOnly"
                            >
                              <template v-slot:label>
                                Profile Name
                                <!-- <span class="red--text">*</span> -->
                              </template>
                            </v-text-field>

                            <div v-if="isOpenProfileDivision">
                              <template v-if="!isExistingProfileSelection">
                                <v-row>
                                  <v-col>
                                <v-text-field
                                  label="Existing File"
                                  v-model="projectData.LoadProfileFile"
                                  :disabled="true"
                                ></v-text-field>
                                  </v-col>
                                  <v-col>                                
                                    <v-text-field
                                      label="Year"
                                      v-model="projectData.LoadProfileYear"
                                      :disabled="true"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col>
                                <v-file-input
                                  label="File input"
                                  v-model="projectData.feederDataCsvFile"
                                  :rules="inputRules"
                                  :disabled="isLoadProfileReadOnly"
                                  @change="onChangedFeederProfileCSV"
                                ></v-file-input>
                                  </v-col>
                                  <v-col>                                
                                    <v-text-field
                                      label="Year"
                                      v-model="projectData.loadProfileYear"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </template>

                              <v-text-field
                                v-model="projectData.substationName"
                                :rules="inputRules"
                                :disabled="isLoadProfileReadOnly"
                              >
                                <template v-slot:label>
                                  Name of Substation
                                  <!-- <span class="red--text">*</span> -->
                                </template>
                              </v-text-field>

                              <v-text-field
                                v-if="projectData.analysisLevel === 'dt'"
                                v-model="projectData.dtName"
                                :rules="inputRules"
                                :disabled="isLoadProfileReadOnly"
                              >
                                <template v-slot:label>
                                  Name of DT
                                  <!-- <span class="red--text">*</span> -->
                                </template>
                              </v-text-field>

                              <v-text-field
                                v-if="
                                  projectData.analysisLevel === 'feeder' ||
                                  projectData.analysisLevel === 'substation'
                                "
                                v-model="projectData.feederName"
                                :rules="inputRules"
                                :disabled="isLoadProfileReadOnly"
                              >
                                <template v-slot:label>
                                  Name of Feeder
                                  <!-- <span class="red--text">*</span> -->
                                </template>
                              </v-text-field>

                              <div
                                v-if="projectData.analysisLevel == 'substation'"
                              >
                                <v-text-field
                                  v-model="projectData.totalCapacityMVA"
                                  type="number"
                                  :disabled="isLoadProfileReadOnly"
                                >
                                  <template v-slot:label>
                                    Total capacity (MVA)
                                    <!-- <span class="red--text">*</span> -->
                                  </template>
                                </v-text-field>
                                <v-text-field
                                  v-model="projectData.incomingFeederVoltageKV"
                                  type="number"
                                  :disabled="isLoadProfileReadOnly"
                                >
                                  <template v-slot:label>
                                    Incoming feeder voltage (kV)
                                    <!-- <span class="red--text">*</span> -->
                                  </template>
                                </v-text-field>
                                <v-text-field
                                  v-model="projectData.outgoingFeederVoltageKV"
                                  type="number"
                                  :disabled="isLoadProfileReadOnly"
                                >
                                  <template v-slot:label>
                                    Outgoing feeder voltage (kV)
                                    <!-- <span class="red--text">*</span> -->
                                  </template>
                                </v-text-field>
                              </div>

                              <v-row>
                                <v-col>
                                  <v-layout row wrap ml-0>
                                    <v-flex>
                                      <v-text-field
                                        label="Pincode"
                                        v-model="projectData.pincode"
                                        :rules="inputRules"
                                        @input="onPincodeChange"
                                        class="width:100px"
                                        :disabled="isLoadProfileReadOnly"
                                      >
                                        <template v-slot:label>
                                          Pincode
                                          <!-- <span class="red--text">*</span> -->
                                        </template>
                                      </v-text-field>
                                    </v-flex>
                                    <v-flex mt-4>
                                      <Tooltips :Tooltip="pincodeTooltip" />
                                    </v-flex>
                                  </v-layout>
                                </v-col>
                                <v-col>
                                  <v-text-field
                                    v-model="projectData.stateName"
                                    label="state"
                                    readonly
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-select
                                v-model="projectData.feederType"
                                :items="feederTypes"
                                item-text="title"
                                item-value="title"
                                label="Feeder Types"
                                :disabled="isLoadProfileReadOnly"
                                :rules="inputRules"
                                @change="
                                  setConductorType(projectData.feederType)
                                "
                              />

                              <v-select
                                v-if="projectData.analysisLevel === 'feeder'"
                                v-model="projectData.feederVoltageKV"
                                :items="feederVoltageKVs"
                                item-text="value"
                                item-value="value"
                                label="Feeder Voltage (kV)"
                                :disabled="isLoadProfileReadOnly"
                                :rules="inputRules"
                              />

                              <!-- <v-text-field
                                v-if="projectData.analysisLevel === 'feeder'"
                                label="Sanctioned Load (MW)"
                                v-model="projectData.sanctionedLoadMW"
                                :rules="inputRules"
                                class="inputField input-name p-3 styled-input"
                                type="number"
                                :disabled="isLoadProfileReadOnly"
                              /> -->

                              <v-text-field
                                v-if="
                                  projectData.analysisLevel === 'substation'
                                "
                                label="Number of Feeders"
                                v-model="projectData.feederCount"
                                :rules="inputRules"
                                class="inputField input-name p-3 styled-input"
                                type="number"
                                :disabled="isLoadProfileReadOnly"
                              />

                              <div
                                v-if="
                                  projectData.analysisLevel === 'dt' ||
                                  projectData.analysisLevel === 'substation'
                                "
                              >
                                <v-text-field
                                  label="Power Factor"
                                  v-model="projectData.powerFactor"
                                  :rules="inputRules"
                                  class="inputField input-name p-3 styled-input"
                                  type="number"
                                  :disabled="isLoadProfileReadOnly"
                                />
                              </div>

                              <div v-if="projectData.analysisLevel === 'dt'">
                                <!-- <v-text-field
                                  label="DT Tapping"
                                  v-model="projectData.dtTapping"
                                  :rules="inputRules"
                                  class="inputField input-name p-3 styled-input"
                                  type="number"
                                  :disabled="isLoadProfileReadOnly"
                                /> -->
                                <v-row>
                                  <v-col>
                                    <v-select
                                      v-model="projectData.dtCapacityKVA"
                                      :items="dtCapacityKVAs"
                                      item-text="text"
                                      item-value="value"
                                      label="DT Capacity (KVA)"
                                      @change="onDTChange()"
                                      :disabled="isLoadProfileReadOnly"
                                    />
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      v-if="showdtCapacityKVAOthers"
                                      v-model="othersDtCapacityKVA"
                                      label="value"
                                      :rules="inputRules"
                                      type="number"
                                  /></v-col>
                                </v-row>
                                <v-select
                                  v-model="projectData.primaryVoltage"
                                  :items="primaryVoltage"
                                  item-text="text"
                                  item-value="value"
                                  label="Primary Voltage (kV)"
                                  @change="onDTChange()"
                                  :disabled="isLoadProfileReadOnly"
                                />

                                <!-- <v-text-field
                                  label="Primary Voltage (kV)"
                                  v-model="projectData.primaryVoltage"
                                  :rules="inputRules"
                                  class="inputField input-name p-3 styled-input"
                                  type="number"
                                  :disabled="isLoadProfileReadOnly"
                                /> -->
                              </div>

                              <v-text-field
                                v-if="projectData.analysisLevel === 'dt'"
                                label="Secondary Voltage (kV)"
                                v-model="projectData.secondaryVoltage"
                                :rules="inputRules"
                                class="inputField input-name p-3 styled-input"
                                type="number"
                                :disabled="isLoadProfileReadOnly"
                              />

                              <v-layout ml-0>
                                <v-flex>
                                  <v-text-field
                                    v-model="projectData.feederLengthKm"
                                    :rules="inputRules"
                                    type="number"
                                    :disabled="isLoadProfileReadOnly"
                                  >
                                    <template v-slot:label>
                                      <div
                                        v-if="
                                          projectData.analysisLevel === 'dt'
                                        "
                                      >
                                        Total LT line length (km)
                                        <!-- <span class="red--text">*</span> -->
                                      </div>
                                      <div
                                        v-if="
                                          projectData.analysisLevel == 'feeder'
                                        "
                                      >
                                        Feeder length (km)
                                        <!-- <span class="red--text">*</span> -->
                                      </div>
                                      <div
                                        v-if="
                                          projectData.analysisLevel ==
                                          'substation'
                                        "
                                      >
                                        Total Feeder length (km)
                                        <!-- <span class="red--text">*</span> -->
                                      </div>
                                    </template>
                                  </v-text-field>
                                </v-flex>
                                <v-flex mt-4>
                                  <Tooltips :Tooltip="feederLengthTooltip" />
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-form>
                        </div>
                      </v-card>

                      <v-card flat outlined>
                        <v-card-title>
                          State level load profile
                          <Tooltips :Tooltip="stateLevelTooltip" />
                          <v-spacer></v-spacer>
                          <v-icon
                            v-if="isEditable"
                            @click="showConfirmBox('StateLevelProfile')"
                            >mdi-close-circle-outline</v-icon
                          >
                        </v-card-title>
                        <div class="ml-10">
                          <v-radio-group
                            v-model="stateProfileSelection"
                            @change="onStateProfileSelectionChange()"
                            :disabled="isStateLevelProfileReadOnly"
                          >
                            <v-radio
                              label="Select an existing profile"
                              color="primary"
                              value="existing_profile"
                            ></v-radio>
                            <v-radio
                              label="Create a new profile"
                              color="primary"
                              value="new_profile"
                            ></v-radio>
                          </v-radio-group>

                          <v-form
                            class="px-3"
                            ref="formStateProfile"
                            @submit.prevent="submit"
                          >
                            <div>
                              <v-row>
                                <v-col>
                                  <v-select
                                    v-if="isShowExistingStateLevelProfile"
                                    v-model="projectData.profileId"
                                    :items="stateLevelProfiles"
                                    item-text="title"
                                    item-value="_id"
                                    label="Select Existing Profile"
                                    :disabled="isStateLevelProfileReadOnly"
                                    :rules="
                                      !projectData.stateLevelLoadProfileFile
                                        .name
                                        ? inputRules
                                        : []
                                    "
                                  />
                                </v-col>
                                <!-- <v-col> 
                                  <v-col>                                
                                    <v-text-field
                                      label="Year"
                                      v-model="projectData.profileYear"
                                      :disabled="isStateLevelProfileReadOnly"
                                    ></v-text-field>
                                  </v-col>
                                </v-col> -->
                              </v-row>

                              <div v-if="!isExistingStateProfileSelection">
                                <v-text-field
                                  v-if="isShowStateLevelPrfoleTitle"
                                  v-model="
                                    projectData.stateLevelLoadProfileTitle
                                  "
                                  :rules="inputRules"
                                  @keyup="onStateLevelPrfoleTitle()"
                                >
                                  <template v-slot:label>
                                    State Level Profile Name
                                    <!-- <span class="red--text">*</span> -->
                                  </template>
                                </v-text-field>
                                <v-row>
                                  <v-col>
                                <v-text-field
                                  v-if="isShowExistFile"
                                  label="Existing File"
                                  v-model="
                                    projectData.stateLevelLoadProfileFile.name
                                  "
                                  :disabled="true"
                                >
                                </v-text-field>
                                  </v-col>
                                  <v-col>                                
                                      <v-text-field
                                        v-if="isShowExistFile"
                                        label="Year"
                                        v-model="projectData.loadProfileYear"
                                        :disabled="true"
                                      ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                  <v-col>
                                <v-file-input
                                  v-if="isShowStateLevelProfileFile"
                                  label="File input"
                                  v-model="projectData.stateLevelCsvFile"
                                  :rules="
                                    !projectData.stateLevelLoadProfileFile.name
                                      ? inputRules
                                      : []
                                  "
                                  @change="onChangedStateProfileCSV"
                                ></v-file-input>
                                </v-col>
                                <v-col>                                
                                    <v-text-field
                                      v-if="isShowStateLevelProfileFile"
                                      label="Year"
                                      v-model="projectData.sloadProfileYear"
                                      :rules="inputRules"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>

                                <v-text-field
                                  v-if="isShowStateLevelPeakLoadDemand"
                                  v-model="projectData.peakLoadDemandMW"
                                  :rules="inputRules"
                                  type="number"
                                  class="
                                    inputField
                                    input-name
                                    p-3
                                    styled-input
                                    ml-8
                                  "
                                  @keyup="onChangePeakLoadDemand()"
                                >
                                  <template v-slot:label>
                                    Peak load demand (MW)
                                    <!-- <span class="red--text">*</span> -->
                                  </template>
                                </v-text-field>

                                <v-datetime-picker
                                  v-if="isShowStateLevelPeakLoadEvent"
                                  v-model="projectData.peakLoadEventTime"
                                  :rules="inputRules"
                                  label="Peak Load Event Time"
                                >
                                  <template v-slot:label>
                                    Peak Load Event Time
                                    <!-- <span class="red--text">*</span> -->
                                  </template>
                                </v-datetime-picker>
                              </div>
                            </div>
                          </v-form>
                        </div>
                      </v-card>
                  <v-layout row wrap ml-0>
                  <v-flex>
                    <v-text-field
                      v-model="projectData.stateLevelDistributedSolarEnergyCapacityAddition"
                      :rules="inputRules"
                      type="number"
                      class="ml-2 mt-8 mb-5 inputField p-3 styled-input"
                      style="width: 500px"
                      :disabled="isLoadProfileReadOnly"
                    >
                      <template v-slot:label>
                        State level distributed solar energy capacity addition
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex mt-4>
                    <Tooltips
                      :Tooltip="
                        stateLevelDistributedSolarEnergyCapacityAdditionTooltip
                      "
                    />
                  </v-flex>
                </v-layout>

                      <div style="margin-left: -25px">
                        <v-expansion-panels flat>
                          <v-expansion-panel>
                            <v-expansion-panel-header
                              expand-icon="mdi-menu-down"
                              class="font-weight-bold"
                            >
                              Advanced inputs (optional)
                            </v-expansion-panel-header>

                            <v-form
                              class="px-3"
                              ref="formProfileAdvance"
                              @submit.prevent="submit"
                            >
                              <v-expansion-panel-content>
                                <v-text-field
                                  label="Analysis period (years)"
                                  v-model="projectData.analysisPeriod"
                                  :disabled="true"
                                />
                                <v-layout row wrap ml-0>
                                  <v-flex>
                                    <v-text-field
                                      label="Upper limit for capacity upgradation (%)"
                                      v-model="
                                        projectData.capacityUpgradationUpperLimit
                                      "
                                      class="
                                        inputField
                                        input-name2
                                        p-3
                                        styled-input
                                      "
                                      :rules="inputRules"
                                      :disabled="true"
                                    />
                                  </v-flex>
                                  <v-flex mt-4>
                                    <Tooltips
                                      :Tooltip="
                                        upperLimitForCapacityUpgradationTooltip
                                      "
                                    />
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap ml-0>
                                  <v-flex>
                                    <v-text-field
                                      label="Percentage of load shifted after upgradation"
                                      v-model="
                                        projectData.loadShiftedAfterUpgradation
                                      "
                                      class="
                                        inputField
                                        input-name2
                                        p-3
                                        styled-input
                                      "
                                      :rules="inputRules"
                                      :disabled="true"
                                    />
                                  </v-flex>
                                  <v-flex mt-4>
                                    <Tooltips
                                      :Tooltip="
                                        percentageOfLadShiftedAfterUpgradationTooltip
                                      "
                                    />
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap ml-0>
                                  <v-flex>
                                    <v-text-field
                                      v-model="
                                        projectData.yearlyChangeInLoadPercent
                                      "
                                      class="
                                        inputField
                                        input-name2
                                        p-3
                                        styled-input
                                      "
                                      :rules="inputRules"
                                      :disabled="true"
                                    >
                                      <template v-slot:label>
                                        Yearly change in load (%)
                                        <!-- <span class="red--text">*</span> -->
                                      </template>
                                    </v-text-field>
                                  </v-flex>
                                  <v-flex mt-4>
                                    <Tooltips
                                      :Tooltip="yearlyChangeInLoadTooltip"
                                    />
                                  </v-flex>
                                </v-layout>

                                <v-layout row wrap ml-0>
                                  <v-flex>
                                    <v-row mx-10>
                                      <v-col>
                                        <v-select
                                          v-model="
                                            projectData.conductorTypeTitle
                                          "
                                          :items="conductorTypes"
                                          item-text="title"
                                          item-value="title"
                                          label="Type of conductor"
                                          class="
                                            inputField
                                            input-name2
                                            p-3
                                            styled-input
                                          "
                                          @change="onChangeConductorTypes()"
                                        />
                                      </v-col>
                                      <v-col>
                                        <!-- <v-btn
                                          outlined
                                          small
                                          fab
                                          @click="
                                            showConfirmBox('conductorType')
                                          "
                                          color="blue"
                                        >
                                          <v-icon>mdi-pencil</v-icon>
                                        </v-btn> -->
                                      </v-col>
                                    </v-row>
                                  </v-flex>
                                  <v-flex mt-4>
                                    <Tooltips
                                      :Tooltip="typeOfConductorTooltip"
                                    />
                                    <!-- <v-icon
                                      @click="showConfirmBox('conductorType')"
                                      >mdi-close-circle-outline</v-icon
                                    > -->
                                  </v-flex>
                                </v-layout>

                                <div>
                                  <v-text-field
                                    v-model="projectData.resistanceOhmsPerKm"
                                    :disabled="
                                      projectData.conductorTypeTitle !==
                                      'Others'
                                    "
                                    type="number"
                                    :rules="
                                      projectData.conductorTypeTitle ===
                                      'Others'
                                        ? inputRules
                                        : []
                                    "
                                  >
                                    <template v-slot:label>
                                      Resistance (ohms/km)
                                    </template>
                                  </v-text-field>
                                  <v-text-field
                                    v-model="projectData.reactanceOhmsPerKm"
                                    type="number"
                                    :disabled="
                                      projectData.conductorTypeTitle !==
                                      'Others'
                                    "
                                    :rules="
                                      projectData.conductorTypeTitle ===
                                      'Others'
                                        ? inputRules
                                        : []
                                    "
                                  >
                                    <template v-slot:label>
                                      Reactance (ohms/km)
                                    </template>
                                  </v-text-field>
                                  <v-text-field
                                    v-model="
                                      projectData.peakCurrentCarryingCapacityAmps
                                    "
                                    :rules="
                                      projectData.conductorTypeTitle ===
                                      'Others'
                                        ? inputRules
                                        : []
                                    "
                                    type="number"
                                    :disabled="
                                      projectData.conductorTypeTitle !==
                                      'Others'
                                    "
                                  >
                                    <template v-slot:label>
                                      Peak current carrying capacity (Amps)
                                    </template>
                                  </v-text-field>
                                </div>
                              </v-expansion-panel-content>
                            </v-form>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card-actions class="justify-center">
                    <v-btn outlined color="primary" @click="e1 = 1">Back</v-btn>
                    <!-- <v-btn outlined color="primary" @click="reset">Reset</v-btn> -->

                    <!-- <v-btn outlined color="primary" @click="submit">Save</v-btn> -->
                    <!-- <v-btn outlined color="primary" @click="e1 = 3"
                        >Next</v-btn
                      > -->
                    <v-btn outlined color="primary" @click="tabTwo()"
                      >Next</v-btn
                    >
                  </v-card-actions>
                </v-stepper-content>

                <v-form
                  class="px-3"
                  ref="formTechnology"
                  @submit.prevent="submit"
                >
                  <v-stepper-content step="3">
                    <v-card width="500" class="mx-auto mt-9" flat>
                      <v-card-text>
                        <v-text-field
                          v-if="
                            projectData.technologyType == 'solar' ||
                            projectData.technologyType == 'solar_plus_storage'
                          "
                          v-model="projectData.solarCapacity"
                          type="number"
                          :rules="[
                            SolarCapacityInputRules.required,
                            projectData.analysisLevel == 'feeder'
                              ? SolarCapacityInputRules.feeder
                              : projectData.analysisLevel == 'dt'
                              ? SolarCapacityInputRules.dt
                              : projectData.analysisLevel == 'substation'
                              ? SolarCapacityInputRules.substation
                              : [],
                          ]"
                        >
                          <template v-slot:label>
                            Solar capacity (MW)
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>

                        <v-select
                          v-if="
                            projectData.technologyType == 'solar' ||
                            projectData.technologyType == 'solar_plus_storage'
                          "
                          v-model="projectData.interconnectionLocationSolar"
                          label="Interconnection Location Solar"
                          :items="solarInterconnectionLocations"
                          item-text="title"
                          item-value="shortName"
                          :rules="inputRules"
                        />

                        <v-text-field
                          v-if="
                            projectData.technologyType == 'storage' ||
                            projectData.technologyType == 'solar_plus_storage'
                          "
                          v-model="projectData.inverterCapacityForStorage"
                          :isRequired="true"
                          :rules="[
                            storageCapacityInputRules.required,
                            projectData.analysisLevel == 'feeder'
                              ? storageCapacityInputRules.feeder
                              : projectData.analysisLevel == 'dt'
                              ? storageCapacityInputRules.dt
                              : projectData.analysisLevel == 'substation'
                              ? storageCapacityInputRules.substation
                              : [],
                          ]"
                          type="number"
                          class="inputField input-name p-3 styled-input"
                        >
                          <template v-slot:label>
                            Inverter capacity for storage (MW)
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-if="
                            projectData.technologyType == 'storage' ||
                            projectData.technologyType == 'solar_plus_storage'
                          "
                          v-model="projectData.storageCapacity"
                          :rules="inputRules"
                          type="number"
                        >
                          <template v-slot:label>
                            Storage capacity (MWh)
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>
                        <v-layout row wrap ml-0>
                          <v-flex>
                            <v-select
                              v-if="
                                projectData.technologyType === 'storage' ||
                                projectData.technologyType ===
                                  'solar_plus_storage'
                              "
                              v-model="
                                projectData.interconnectionLocationStorage
                              "
                              label="Interconnection Location Storage"
                              :items="storageInterconnectionLocations"
                              item-text="title"
                              item-value="shortName"
                              :rules="inputRules"
                            >
                            </v-select>
                          </v-flex>
                          <v-flex mt-4>
                            <Tooltips
                              :Tooltip="interconnectionLocationStorageTooltip"
                              v-if="
                                projectData.technologyType == 'storage' ||
                                projectData.technologyType ==
                                  'solar_plus_storage'
                              "
                            />
                          </v-flex>
                        </v-layout>

                        <v-select
                          v-if="
                            projectData.technologyType == 'storage' ||
                            projectData.technologyType == 'solar_plus_storage'
                          "
                          v-model="
                            projectData.storageChargingDischargingStrategy
                          "
                          label="Storage charging/discharging strategy"
                          :items="storageChargingDischargingStrategies"
                          item-text="title"
                          item-value="value"
                          :rules="inputRules"
                        >
                        </v-select>
                      </v-card-text>
                    </v-card>
                    <v-card-actions class="justify-center">
                      <v-btn outlined color="primary" @click="e1 = 2"
                        >Back</v-btn
                      >
                      <v-btn outlined color="primary" @click="resetTechnology()"
                        >Reset</v-btn
                      >
                      <v-btn outlined color="primary" @click="submit(true)"
                        >Save & Next</v-btn
                      >
                      <!-- <v-btn outlined color="primary" @click="tabFour()"
                        >Next</v-btn
                      > -->
                    </v-card-actions>
                  </v-stepper-content>
                </v-form>

                <v-stepper-content step="4">
                  <v-card width="800" class="mx-auto mt-9" flat>
                    <v-card-text>
                      <v-form
                        class="px-3"
                        ref="formVoder"
                        @submit.prevent="submit"
                      >
                        <v-card flat>
                          <div style="font-size: x-large;">
                            Marginal cost of energy to be replaced (INR/kWh)
                            <Tooltips :Tooltip="marginalCostOfEnergyTooltip" />
                            <v-spacer></v-spacer>
                          </div>
                          <br>
                          <div>
                              <v-select
                                v-model="
                                  projectData.marginalCostOfReplacedEnergyMetricType
                                "
                                :items="marginalCostSelectList"
                                item-text="text"
                                item-value="value"
                                label="Marginal cost of energy to be replaced"
                                @change="
                                  selectMarginalCostItem(
                                    projectData.marginalCostOfReplacedEnergyMetricType
                                  )
                                "
                              />
                          </div>
                          <v-row v-if="marginalCostOfReplacedEnergyMetricType === 'hourly_cost_of_supply_for_one_year'">
                            <v-col>
                              <v-file-input v-if="marginalCostOfReplacedEnergyMetricType === 'hourly_cost_of_supply_for_one_year'"
                                label="File Date"
                                v-model="
                                  projectData.marginalCostOfReplacedEnergyMetricDataFile
                                "
                                :rules="inputRules"
                                @change="onChangedMarginalCSV"
                              ></v-file-input>
                            </v-col>
                            <v-col>                                
                              <v-text-field
                                label="Year"
                                v-model="projectData.sloadProfileYear"
                                :rules="inputRules"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="marginalCostOfReplacedEnergyMetricType === 'cost_as_per_iex_data'">
                            <v-col>
                              <v-file-input v-if="marginalCostOfReplacedEnergyMetricType === 'cost_as_per_iex_data'"
                                label="File Data"
                                v-model="
                                  projectData.marginalCostOfReplacedEnergyMetricDataFile
                                "
                                :rules="inputRules"
                                @change="onChangedMarginalCSV"
                              ></v-file-input>
                            </v-col>
                            <v-col>                                
                              <v-text-field
                                label="Year"
                                v-model="projectData.sloadProfileYear"
                                :rules="inputRules"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                              <div
                                v-if="
                                  marginalCostOfReplacedEnergyMetricType ===
                                  'marginal_cost_of_generator_to_be_replaced'
                                "
                              >
                                <v-text-field
                                  v-model="
                                    projectData.marginalCostOfReplacedEnergyMetricData
                                  "
                                  :rules="inputRules"
                                >
                                  <template v-slot:label>
                                    {{ marginalCostLable }}
                                  </template>
                                </v-text-field>
                              </div>
                              <div
                                v-if="
                                  marginalCostOfReplacedEnergyMetricType ===
                                  'database'
                                "
                              >
                                <v-select
                                  :rules="inputRules"
                                  v-model="
                                    projectData.marginalCostOfReplacedEnergyMetricData
                                  "
                                  :items="
                                    marginalCostOfReplacedEnergyMetricRecords
                                  "
                                  item-text="title"
                                  item-value="_id"
                                  label="Marginal Cost Of Replaced Energy Metric Data File"
                                />
                              </div>
                        </v-card>
                        <v-text-field
                          v-model="projectData.avgTransmissionLosses"
                          :rules="inputRules"
                          type="number"
                        >
                          <template v-slot:label>
                            Average transmission losses (%)
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>
                      </v-form>

                      <v-expansion-panels flat>
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            expand-icon="mdi-menu-down"
                            class="font-weight-bold"
                          >
                            Advanced inputs (optional)
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-layout row wrap ml-0>
                              <v-flex>
                                <v-text-field
                                  label="Transmission capacity cost (INR/MW)"
                                  v-model="projectData.transmissionCapacityCost"
                                  class="
                                    inputField
                                    input-name2
                                    p-3
                                    styled-input
                                  "
                                  :rules="inputRules"
                                  type="number"
                                />
                              </v-flex>
                              <v-flex mt-4>
                                <Tooltips
                                  :Tooltip="transmissionCapacityCostTooltip"
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap ml-0>
                              <v-flex>
                                <v-text-field
                                  label="Generation capacity cost (INR/MW)"
                                  v-model="projectData.generationCapacityCost"
                                  class="
                                    inputField
                                    input-name2
                                    p-3
                                    styled-input
                                  "
                                  :rules="inputRules"
                                  type="number"
                                />
                              </v-flex>
                              <v-flex mt-4>
                                <Tooltips
                                  :Tooltip="generationCapacityCostTooltip"
                                />
                              </v-flex>
                            </v-layout>

                            <v-text-field
                              label="Discount Factor"
                              v-model="projectData.discountFactor"
                              type="number"
                              :rules="inputRules"
                            />

                            <v-text-field
                              label="Interest Rate"
                              v-model="projectData.interestRate"
                              type="number"
                              :rules="inputRules"
                            />

                            <v-card class="mt-9" flat>
                              <v-card flat outlined>
                                <v-card-text>
                                  <v-card-title>
                                    Cost of Upgradation
                                  </v-card-title>

                                  <v-text-field
                                    label="Cost In Lakhs"
                                    v-model="projectData.costInLakhs"
                                    type="number"
                                    :rules="inputRules"
                                  />
                                </v-card-text>
                              </v-card>
                            </v-card>

                            <v-text-field
                              label="Cost of CO2 (INR/Kg)"
                              v-model="projectData.emissionCostCo2"
                              type="number"
                              :rules="inputRules"
                            />
                            <v-text-field
                              label="Cost of NO2 (INR/Kg)"
                              v-model="projectData.emissionCostNo2"
                              type="number"
                              :rules="inputRules"
                            />

                            <v-text-field
                              label="Cost of SO2 (INR/Kg)"
                              v-model="projectData.emissionCostSo2"
                              type="number"
                              :rules="inputRules"
                            />
                            <v-text-field
                              label="Cost of PM2.5 (INR/Kg)"
                              v-model="projectData.emissionCostSPM2_5"
                              type="number"
                              :rules="inputRules"
                            />
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card-text>
                  </v-card>
                  <v-card-actions class="justify-center">
                    <v-btn outlined color="primary" @click="e1 = 3">Back</v-btn>
                    <v-btn outlined color="primary" @click="resetVoder"
                      >Reset</v-btn
                    >
                    <v-btn outlined color="primary" @click="submit(false)"
                      >Save & Run</v-btn
                    >
                  </v-card-actions>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
    <ConfirmationBox
      confirmationTitle="Change Data"
      :bodyText="confirmationMessage"
      :visible="ShowChangeConfirmation"
      @close="changeConfirm"
    />
    <MessageBox
      confirmationTitle="Ready for Analysis"
      bodyText="Ready for Analysis"
      :visible="isSowfinalMessage"
      @closeBox="closeBox"
    />
    <fileMessageBox
      confirmationTitle="Error in input file"
      :bodyText="errorDescription"
      :visible="isShowErrorMessage"
      @closeBox="closeErrorBox(erroFileInput)"
    />
    <ConfirmationDialog
      :dialogTitle="confirmationDialogProps.title"
      :positiveActionText="confirmationDialogProps.positiveActionText"
      :negativeActionText="confirmationDialogProps.negativeActionText"
      :bodyText="confirmationDialogProps.message"
      :visible="confirmationDialogProps.isVisible"
      @close="confirmationDialogProps.onClose"
      :showNegativeAction="confirmationDialogProps.isNegativeShow"
    />
  </div>
</template>
<script>
import ConfirmationDialog from "@/components/ConfirmationDialog";

import { bus } from "../main.js";
import { formatInputDate, displayDateTime } from "@/utility/dateTime.js";
import AdminFeederStore from "@/services/adminfeederstore.js";
import DataList from "@/services/dataliststore.js";
import ProjectService from "@/services/ProjectService.js";
import ConfirmationBox from "@/components/deleteConfirmation.vue";
import Tooltips from "@/components/tooltips.vue";
import TooltipsData from "@/services/lableTooltips.js";
import PincodeService from "@/services/pincodeservice.js";
import csvFile from "@/services/csvFile";
import dataService from "@/libs/dataService.js";
import staticMasterdataService from "@/libs/staticMasterData.js";
import MessageBox from "@/components/messageBox.vue";
import fileMessageBox from "@/components/messageBox.vue";
import { projectStatus } from "../utility/constants";
export default {
  name: "NewEditProject",
  props: ["visible", "ProjectData", "EditMode", "WindowLable", "viewMode"],
  components: {
    Tooltips,
    ConfirmationBox,
    MessageBox,
    ConfirmationDialog,
    fileMessageBox,
  },
  data() {
    return {
      storeConductorType: [],
      primaryVoltage: [],
      erroFileInput: null,
      errorDescription: "",
      isShowErrorMessage: false,
      confirmationDialogProps: {
        message: "",
        title: "",
        isVisible: false,
        onClose: () => {},
        isNegativeShow: true,
        positiveActionText: "Yes",
        negativeActionText: "No",
      },
      showdtCapacityKVAOthers: false,
      analysislevel: "",
      isChangedFeederProfileCSV: false,
      isChangedStateProfileCSV: false,
      isChangedMarginalCSV: false,
      tempLoadProfileId: null,
      isStateLevelCsvChanged: false,
      isLoadProfileCsvChange: false,
      status: "",
      oldProjectTitle: "",
      oldProjectTechnologyType: "",
      isSowfinalMessage: false,
      isShowExistingStateLevelProfile: false,
      isShowExistFile: false,
      isShowStateLevelPrfoleTitle: false,
      isShowStateLevelProfileFile: false,
      isShowStateLevelPeakLoadDemand: false,
      isShowStateLevelPeakLoadEvent: false,

      isOpenProfileDivision: true,
      isOpenStateProfileDivision: true,
      profileSelection: "existing_profile",
      stateProfileSelection: "existing_profile",
      isShowField: true,
      timeProps: {
        useSeconds: false,
        ampmInTitle: false,
      },
      upgradationCostMappingDetails: [],
      marginalCostOfReplacedEnergyMetricType: "",
      marginalCostLable: "",
      changeData: "",

      isAnalysisLevelReadOnly: true,
      isTechnologyReadOnly: false,
      isLoadProfileReadOnly: true,
      isProjectTitleReadOnly: true,
      isStateLevelProfileReadOnly: true,
      isConductorTypeReadOnly: true,
      isMarginalCostOfEnergyReadOnly: true,

      ShowChangeConfirmation: false,
      confirmationMessage: "",
      analysisLevels: [],
      technologyTypes: [],
      feederVoltageKVs: [],
      secondaryVoltages: [],
      dtCapacityKVAs: [],
      othersDtCapacityKVA: null,
      conductorTypes: [],
      marginalCostOfReplacedEnergyMetricRecords: [],
      solarInterconnectionLocations: [],
      storageChargingDischargingStrategies: [],
      storageInterconnectionLocations: [],
      selectedProfile: null,
      loadProfilesAll: [],
      selectedMarginalCostOfReplacedEnergyMetricData: "",
      feederTypes: [],
      selected: "",
      e1: 1,
      errorMsg: "",
      Notification: false,
      dtLoadProfileTooltip: "",
      substationProfileTooltip: "",
      htLoadProfileTooltip: "",
      pincodeTooltip: "",
      feederLengthTooltip: "",
      sanctionedTooltip: "",
      stateLevelTooltip: "",
      yearlyChangeInLoadTooltip: "",
      typeOfConductorTooltip: "",
      marginalCostOfEnergyTooltip: "",
      interconnectionLocationStorageTooltip: "",
      stateLevelLoadTooltip: "",
      upperLimitForCapacityUpgradation: "",
      percentageOfLadShiftedAfterUpgradationTooltip: "",
      upperLimitForCapacityUpgradationTooltip: "",
      transmissionCapacityCostTooltip: "",
      costOfUpgradationTootip: "",
      stateLevelDistributedSolarEnergyCapacityAdditionTooltip :"",
      conductortype: "",
      generationCapacityCostTooltip: "",
      selectedProfileFile: null,
      changeinloadyearly: "",
      dbFileEntity: [],
      stateLevelProfiles: [],
      substationProfileFileList: [],
      htProfileFileList: [],
      dtProfileFileList: [],
      inputRules: [(v) => !!v || "This field is required"],
      SolarCapacityInputRules: {
        required: (value) => !!value || "This field is required",
        feeder: (v) =>
          v <=
            (this.projectData.feederVoltageKV *
              this.projectData.peakCurrentCarryingCapacityAmps *
              1.732) /
              1000 ||
          `value should be below or equal to ${
            (this.projectData.feederVoltageKV *
              this.projectData.peakCurrentCarryingCapacityAmps *
              1.732) /
            1000
          }`,

        dt: (v) =>
          v <=
            (this.showdtCapacityKVAOthers
              ? this.othersDtCapacityKVA / 1000
              : this.projectData.dtCapacityKVA / 1000) ||
          `value should be below or equal to ${
            this.showdtCapacityKVAOthers
              ? this.othersDtCapacityKVA / 1000
              : this.projectData.dtCapacityKVA / 1000
          }`,

        // v <= this.projectData.dtCapacityKVA / 1000 ||
        // `value should be below or equal to ${
        //   this.projectData.dtCapacityKVA / 1000
        // }`,
        substation: (v) =>
          v <= this.projectData.totalCapacityMVA ||
          `value should be below or equal to ${this.projectData.totalCapacityMVA}`,
      },

      storageCapacityInputRules: {
        required: (value) => !!value || "This field is required",
        feeder: (v) =>
          v <=
            (this.projectData.feederVoltageKV *
              this.projectData.peakCurrentCarryingCapacityAmps *
              1.25) /
              1000 ||
          `value should be below or equal to ${
            (this.projectData.feederVoltageKV *
              this.projectData.peakCurrentCarryingCapacityAmps *
              1.25) /
            1000
          }`,

        dt: (v) =>
          v <=
            (this.showdtCapacityKVAOthers
              ? this.othersDtCapacityKVA / 1000
              : this.projectData.dtCapacityKVA / 1000) ||
          `value should be below or equal to ${
            this.showdtCapacityKVAOthers
              ? this.othersDtCapacityKVA / 1000
              : this.projectData.dtCapacityKVA / 1000
          }`,
        // v <= this.projectData.dtCapacityKVA / 1000 ||
        // `value should be below or equal to ${
        //   this.projectData.dtCapacityKVA / 1000
        // }`,
        substation: (v) =>
          v <= this.projectData.totalCapacityMVA ||
          `value should be below or equal to ${this.projectData.totalCapacityMVA}`,
      },

      marginalCostSelectList: [],
      tabOneMessage: "",
      tabTwoMessage: "",
      tabThreeMessage: "",
      tabFourMessage: "",
      selecteddtCapacityKVA: null,
      selectedsecondaryVoltage: null,
      marginalCostOfReplacedEnergyMetricDataFile: null,
      response: [],

      projectData: {
        fileData: {
          isNewLoadProfileFile: false,
          isLoadLevelFileExist: false,
          isNewStateLevelLodProfileFile: false,
          isStateLevelFileExist: false,
          isNewMetricFile: false,
        },
        _id: "",
        analysisLevel: "",
        technologyType: "",
        title: "",
        loadProfileId: null,
        profileType: "",
        loadProfileTitle: "",
        feederDataCsvFile: [],
        substationName: "",
        dtName: "",
        feederName: "",
        totalCapacityMVA: "",
        incomingFeederVoltageKV: "",
        outgoingFeederVoltageKV: "",
        pincode: "",
        stateName: "",
        feederType: "",
        feederVoltageKV: "",
        voltageLevelsKV: "",
        sanctionedLoadMW: "",
        feederCount: "",
        powerFactor: "",
        dtTapping: "",
        dtCapacityKVA: "",
        primaryVoltage: "",
        secondaryVoltage: "",
        feederLengthKm: "",
        profileId: null,
        loadProfileYear:"",
        LoadProfileFile: "",
        stateLevelLoadProfileFile: "",
        stateLevelLoadProfileTitle: "",
        stateLevelDistributedSolarEnergyCapacityAddition:"",
        stateLevelCsvFile: [],
        peakLoadDemandMW: "",
        peakLoadEventTime: "",
        analysisPeriod: "",
        capacityUpgradationUpperLimit: "",
        loadShiftedAfterUpgradation: "",
        yearlyChangeInLoadPercent: "",
        conductorTypeTitle: "",
        resistanceOhmsPerKm: "",
        reactanceOhmsPerKm: "",
        peakCurrentCarryingCapacityAmps: "",
        solarCapacity: null,
        interconnectionLocationSolar: null,
        interconnectionLocationStorage: null,
        inverterCapacityForStorage: null,
        storageCapacity: null,
        storageChargingDischargingStrategy: null,
        marginalCostOfReplacedEnergyMetricType: "",
        marginalCostOfReplacedEnergyMetricDataFile: "",
        marginalCostOfReplacedEnergyMetricData: "",
        marginalCostOfReplacedEnergyMetricRecords: [],
        avgTransmissionLosses: null,
        transmissionCapacityCost: "",
        generationCapacityCost: "",
        discountFactor: "",
        interestRate: 6.5,
        costInLakhs: "",
        emissionCostCo2: "",
        emissionCostSo2: "",
        emissionCostNo2: "",
        emissionCostSPM2_5: "",
        status: "inputs_required",
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close", this.response);
        }
      },
    },
    isExistingProfileSelection() {
      return this.profileSelection === "existing_profile";
    },
    isExistingStateProfileSelection() {
      return this.stateProfileSelection === "existing_profile";
    },
    isPeakLoadDemandMWAndPeakLoadEventTimeSection() {
      if (this.stateLevelProfile.title.length > 0) {
        return false;
      } else {
        return true;
      }
    },

    isEditable() {
      return false;
      // if (
      //   this.status === "inputs_required" ||
      //   this.status === "analysis_ready_bau"
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }
    },
  },
  created() {
    this.getLoadProfiles();
    this.fillAnalysisLevels();
    this.fillTechnologyTypes();
    this.fillFeederTypes();
    this.fillDTCapacityKVA();
    // this.fillsecondaryVoltage();
    this.fillFeederVoltageKV();
    this.fillConductorTypes();
    this.fillToolTips();

    this.fillMarginalCostSelectList();
    this.fillStorageChargingDischargingStrategy();
    this.fillMarginalCostOfReplacedEnergyMetricData();
    this.fillTechnologyLocationData();
  },
  methods: {
    onFileChange(file, ctrl) {
       if(file){
        const isV_ModelTrigger = file.name.split('_')[1] ==='finalFile' ? true : false; 
        if(!isV_ModelTrigger){
          this.validateCsv(file, ctrl);  
        }
      }
    },
    setConductorType(feederType) {
      const tempData = [...this.storeConductorType];
      const fillteredConductorType = tempData.filter(
        (d) => d.feederType === feederType || d.title === "Others"
      );
      this.conductorTypes = fillteredConductorType;
    },
    overWriteCostInLaksh() {
     if (
        this.upgradationCost.costInLakhs === 0 ||
        !this.upgradationCost.costInLakhs
      ) {
        const costMaping = this.upgradationCostMappingDetails.find(
          (f) =>
            f.analysisLevel === this.projectData.analysislevel &&
            f.dtCapacityKVA === "others" &&
            f.voltageLevelsKV === this.projectData.primaryVoltage
        );
        this.upgradationCost.costInLakhs = costMaping.costInLakhs;
      }
    },
    async validateCsv(file, ctrl) {
      let isGreaterValueValidattion = false;
      if (ctrl !== "projectData.stateLevelCsvFile") {
        isGreaterValueValidattion = true;
      }
       return csvFile.isValideCSV(file, isGreaterValueValidattion).then((a)=>{
        if ( a && a.status === false) {
          this.erroFileInput = ctrl;
          this.errorDescription = a.message;
          this.showMessage(ctrl);
           return false
        }
        else if(a && a.data && a.status === true){
           this.setCSVDataToVModel(a.data[0],ctrl)
           return true
        }
      });
    },
    setCSVDataToVModel(csvdata,ctrl){
      console.log('calling',ctrl)
      if(ctrl ==='projectData.stateLevelCsvFile'){
        this.projectData.stateLevelCsvFile=csvdata
      }
      if(ctrl ==='projectData.feederDataCsvFile'){
        this.projectData.feederDataCsvFile=csvdata
      }
      if(ctrl ==='projectData.marginalCostOfReplacedEnergyMetricDataFile'){
        // console.log('metricDataFile',csvdata)
        this.projectData.marginalCostOfReplacedEnergyMetricDataFile=csvdata
      }
    },
    closeErrorBox(ctrl) {
      if (ctrl === "projectData.feederDataCsvFile") {
        this.projectData.feederDataCsvFile = null;
      }
      if (ctrl === "projectData.stateLevelCsvFile") {
        this.projectData.stateLevelCsvFile = null;
      }
      if (ctrl === "projectData.marginalCostOfReplacedEnergyMetricDataFile") {
        this.projectData.marginalCostOfReplacedEnergyMetricDataFile = null;
      }
      this.isShowErrorMessage = false;
    },

    showMessage(ctrl) {
      this.erroFileInput = ctrl;
      this.isShowErrorMessage = true;
    },
    showRunAnalysisDialog() {
      if (this.e1 === 4) {
        this.confirmationDialogProps.onClose = this.startAnalysis;
        this.confirmationDialogProps.title = "VODER analysis begins";
        this.confirmationDialogProps.message =
          "Project data cannot be modified once analysis begins. Do you want to proceed?";
        this.confirmationDialogProps.negativeActionText = "No";
        this.confirmationDialogProps.isVisible = true;
        this.confirmationDialogProps = { ...this.confirmationDialogProps };
      }
    },
    showAnalysisProcessDialog() {
      if (this.e1 === 4) {
        this.confirmationDialogProps.onClose = this.redirectToDashboard;
        this.confirmationDialogProps.title = "The analysis is in progress";
        this.confirmationDialogProps.message =
          "The analysis is in progress and will take a few minutes. You will receive an email once the analysis is completed.";
        // this.confirmationDialogProps.message ="The analysis for this project will begin now and all project data can no more be modified. Do you want to proceed?";
        this.confirmationDialogProps.positiveActionText = "Ok";
        this.confirmationDialogProps.isVisible = true;
        this.confirmationDialogProps.isNegativeShow = false;
        this.confirmationDialogProps = { ...this.confirmationDialogProps };
      }
    },
    redirectToDashboard() {
      this.resetDialogProps();
      this.$emit("close", this.response);
      // this.$router.push("/dashboard");
    },
    startAnalysis(shouldStart) {
      this.confirmationDialogProps.isVisible = false;
      this.confirmationDialogProps = {
        ...this.confirmationDialogProps,
        negativeActionText: "No",
      };
      if (shouldStart) {
        this.updateProjectStatus(
          this.projectData._id,
          projectStatus.ANALYSIS_READY_DER
        );
        this.resetDialogProps();
      }
    },
    resetDialogProps() {
      this.confirmationDialogProps = {
        ...this.confirmationDialogProps,
        isVisible: false,
        message: "",
        title: "",
        negativeActionText: "No",
        onClose: () => {},
      };
    },

    updateProjectStatus(projectId, status) {
      ProjectService.updateProjectStatus(projectId, status)
        .then(() => {
          bus.$emit(
            "analysisStartNotification",
            "Analysis has started succesfully."
          );
          this.resetDialogProps();
          this.showAnalysisProcessDialog();
        })
        .catch(() => {
          bus.$emit(
            "errorNotification",
            "An error occured when starting the analysis for the project"
          );
        });
    },

    saveCSVFile(id, type, file, data) {
      if (type) {
        if (type === "feeder") {
          ProjectService.saveFile(id, "feeder", file, data)
            .then(() => {
              return true;
            })
            .catch((error) => {
              return false;
            });
        }
        if (type === "state") {
          return true;
        }
        if (type === "margine") {
          return true;
        }
      }
      return false;
    },
    onChangedFeederProfileCSV() {
      this.onFileChange(
        this.projectData.feederDataCsvFile,
        "projectData.feederDataCsvFile"
      );
      this.isChangedFeederProfileCSV = true;
    },
    onChangedStateProfileCSV() {
      this.onFileChange(
        this.projectData.stateLevelCsvFile,
        "projectData.stateLevelCsvFile"
      );
      this.isChangedStateProfileCSV = true;
    },
    onChangedMarginalCSV() {
      this.onFileChange(
        this.projectData.marginalCostOfReplacedEnergyMetricDataFile,
        "projectData.marginalCostOfReplacedEnergyMetricDataFile"
      );
      this.isChangedMarginalCSV = true;
    },
    resetTechnology() {
      this.$refs.formTechnology.reset();
    },
    resetVoder() {
      this.$refs.formVoder.reset();
    },
    closeBox() {
      this.isSowfinalMessage = false;
    },
    onChangePeakLoadDemand() {
      if (this.projectData.peakLoadDemandMW !== "") {
        this.isShowStateLevelPrfoleTitle = false;
        this.isShowStateLevelProfileFile = false;
        this.isShowExistFile = false;
      } else {
        this.isShowExistFile = true;
        this.isShowStateLevelPrfoleTitle = true;
        this.isShowStateLevelProfileFile = true;
      }
    },

    onStateLevelPrfoleTitle() {
      if (this.projectData.stateLevelLoadProfileTitle !== "") {
        this.isShowExistFile = false;
        this.isShowStateLevelPeakLoadDemand = false;
        this.isShowStateLevelPeakLoadEvent = false;
      } else {
        this.isShowExistFile = true;
        this.isShowStateLevelPeakLoadDemand = true;
        this.isShowStateLevelPeakLoadEvent = true;
        this.isShowStateLevelPrfoleTitle = true;
      }
    },
    onProfileSelectionChange() {
      this.isOpenProfileDivision = true;
      if (this.profileSelection === "existing_profile") {
        this.projectData.loadProfileId = this.tempLoadProfileId;
        // this.selectedProfile = "";
        // this.feederData.title = "";
        // this.feederData.csvFile = null;
      } else {
        this.projectData.loadProfileId = null;
        // this.resetProfileFields();
      }
    },
    onStateProfileSelectionChange() {
      this.isOpenStateProfileDivision = true;
      if (this.stateProfileSelection === "existing_profile") {
        this.isShowExistingStateLevelProfile = true;
        this.isShowStateLevelProfileFile = false;
      } else {
        this.isShowExistingStateLevelProfile = false;
        this.projectData.profileId = null;
        this.isShowStateLevelProfileFile = true;
        this.isShowStateLevelPeakLoadDemand = true;
        this.isShowStateLevelPeakLoadEvent = true;
        this.isShowStateLevelPrfoleTitle = true;
      }
    },

    fillTechnologyLocationData() {
      this.solarInterconnectionLocations =
        staticMasterdataService.getInterconnectionLocationSolar();
      this.storageInterconnectionLocations =
        staticMasterdataService.getInterconnectionLocationStorage();
    },
    showConfirmBox(option) {
      this.ShowChangeConfirmation = true;
      this.changeData = option;
      if (option === "Analysis") {
        this.confirmationMessage =
          "Changing the of Analysis type will clear profile data, Are you sure want to change the analysis type?";
      } else if (option === "Technology") {
        this.confirmationMessage =
          "Changing the Technology type will clear technology data, Are you sure want to change the Technology type?";
      } else if (option === "LoadProfile") {
        this.confirmationMessage =
          "Changing the Profile will delete profile data, Are you sure want to change the Profile?";
      } else if (option === "StateLevelProfile") {
        this.confirmationMessage =
          "Changing the State Leve Profile will delete state level profile data, Are you sure want to change the state level profile?";
      } else if (option === "conductorType") {
        this.confirmationMessage =
          "Changing the conductorType will delete conductor data, Are you sure want to change the conductorType?";
      } else if (option === "MarginalCostOfEnergy") {
        this.confirmationMessage =
          "Changing the Marginal Cost Of Energy will delete MarginalCost Of Energy data, Are you sure want to change the Marginal Cost Of Energy?";
      }
    },

    async isShowStateLevelPrfile() {
      if (this.projectData.profileId) {
        this.isShowExistingStateLevelProfile = true;
      }

      if (this.projectData.stateLevelLoadProfileFile !== "") {
        this.isShowExistFile = true;
        this.isShowStateLevelProfileFile = true;
      }

      if (this.projectData.peakLoadDemandMW !== "") {
        this.isShowStateLevelPeakLoadDemand = true;
        this.isShowStateLevelPeakLoadEvent = true;
      }

      // this.isShowExistFile =true
      // this.isShowStateLevelPrfoleTitle= true
      // this.isShowStateLevelProfileFile= true
      // this.isShowStateLevelPeakLoadDemand=true
      // this.isShowStateLevelPeakLoadEvent=true
    },

    showStateLevelPrfile() {
      this.isShowExistFile = true;
      this.isShowStateLevelPrfoleTitle = true;
      this.isShowStateLevelProfileFile = true;
      this.isShowStateLevelPeakLoadDemand = true;
      this.isShowStateLevelPeakLoadEvent = true;
    },
    resetProfile() {
      this.$refs.formProfile.reset();
      this.isOpenProfileDivision = false;
    },
    resetStateProfile() {
      this.isOpenStateProfileDivision = false;
      this.$refs.formStateProfile.reset();
    },
    clearDTInputFields() {
      this.resetProfile();
    },
    changeConfirm(e) {
      this.confirmationDialogProps.isVisible = false;
      this.confirmationDialogProps = { ...this.confirmationDialogProps };
      if (e === true) {
        this.submit(false);
        this.e1 = 3;
      } else {
        this.submit(false);
        this.e1 = 2;
      }
      // this.ShowChangeConfirmation = false;
      // if (e && this.changeData === "Analysis") {
      //   this.isAnalysisLevelReadOnly = false;
      // } else if (!e && this.changeData === "Analysis") {
      //   this.isAnalysisLevelReadOnly = true;
      // }

      // if (e && this.changeData === "Technology") {
      //   this.isTechnologyReadOnly = false;
      // } else if (!e && this.changeData === "Technology") {
      //   this.isTechnologyReadOnly = true;
      // }

      // if (e && this.changeData === "LoadProfile") {
      //   this.isLoadProfileReadOnly = false;
      //   this.clearDTInputFields();
      // } else if (!e && this.changeData === "LoadProfile") {
      //   this.isLoadProfileReadOnly = true;
      // }

      // if (e && this.changeData === "StateLevelProfile") {
      //   this.stateProfileSelection = "existing_profile";
      //   this.isShowExistingStateLevelProfile = true;
      //   this.resetStateProfile();
      //   this.showStateLevelPrfile();
      //   this.isStateLevelProfileReadOnly = false;
      //   this.projectData.isStateLevelFileExist = false;
      // } else if (!e && this.changeData === "StateLevelProfile") {
      //   this.isStateLevelProfileReadOnly = true;
      // }

      // if (e && this.changeData === "conductorType") {
      //   this.isConductorTypeReadOnly = false;
      // } else if (!e && this.changeData === "conductorType") {
      //   this.isConductorTypeReadOnly = true;
      // }

      // if (e && this.changeData === "MarginalCostOfEnergy") {
      //   this.isMarginalCostOfEnergyReadOnly = false;
      //   this.projectData.marginalCostOfReplacedEnergyMetricDataFile = "";
      //   this.marginalCostOfReplacedEnergyMetricData = "";
      //   this.projectData.marginalCostOfReplacedEnergyMetricData = "";
      // } else if (!e && this.changeData === "MarginalCostOfEnergy") {
      //   this.isMarginalCostOfEnergyReadOnly = true;
      // }
    },
    fillMarginalCostSelectList() {
      this.marginalCostSelectList =
        staticMasterdataService.getMarginalCostSelectList();
    },
    fillDTCapacityKVA() {
      this.dtCapacityKVAs = staticMasterdataService.getDTCapacityKVA();
    },
    fillsecondaryVoltage() {
      this.secondaryVoltages = staticMasterdataService.getSecondaryVoltage();
    },
    fillMarginalCostOfReplacedEnergyMetricData() {
      dataService
        .list("marginalCostOfReplacedEnergyRecords/published")
        .then((res) => {
          this.marginalCostOfReplacedEnergyMetricRecords = res;
        });
    },
    fillFeederTypes() {
      dataService.list("feederTypes").then((res) => {
        this.feederTypes = res;
      });
    },
    fillTechnologyTypes() {
      dataService.list("technologyTypes/active").then((res) => {
        this.technologyTypes = res;
      });
    },
    fillConductorTypes() {
      dataService.list("conductorTypes/published").then((res) => {
        this.conductorTypes = res;
        this.storeConductorType = res;
        const item = {
          peakCurrentCarryingCapacityAmps: "",
          reactanceOhmsPerKm: "",
          resistanceOhmsPerKm: "",
          title: "Others",
        };
        this.conductorTypes.push(item);
        this.storeConductorType.push(item);
      });
    },
    fillFeederVoltageKV() {
      dataService.list("feederVoltageKV").then((res) => {
        this.feederVoltageKVs = res;
      });
    },
    fillAnalysisLevels() {
      dataService.list("analysisLevels/active").then((res) => {
        this.analysisLevels = res;
      });
    },
    fillStorageChargingDischargingStrategy() {
      this.storageChargingDischargingStrategies =
        staticMasterdataService.getStorageChargingDischargingStrategy();
    },
    async getLoadProfiles() {
      const res = await DataList.methods.fetchData("loadProfiles/published");
      this.loadProfilesAll = res;
      this.stateLevelProfiles = this.loadProfilesAll.filter(
        (profile) => profile.profileType === "state_level"
      );
      this.upgradationCostMappingDetails =
        await this.getAllupgradationCostMappings();
      this.FillData();
      this.fillExistinfProfiles();
      this.isShowStateLevelPrfile();
    },
    // onFileChange() {
    //   // this.csvFile = this.projectData.feederDataCsvFile;
    //   // this.testcsv();
    // },
    // async testcsv() {
    //   const a = await csvFile.isValideCSV(this.csvFile);
    //   console.log("task completed", a);
    // },
    onChangeExistingProfile() {
      this.isOpenProfileDivision = true;
      const profileValues = this.loadProfilesAll.filter(
        (profile) => profile._id === this.projectData.loadProfileId
      );
      this.fillLoadProfileData(profileValues[0]);
      this.setConductorType(profileValues[0].feederType);
    },
    fillPrimarVoltage() {
      this.primaryVoltage = staticMasterdataService.getPrimaryVoltage();
    },
    onDTChange() {
      if (this.projectData.dtCapacityKVA === "others") {
        this.showdtCapacityKVAOthers = true;
      } else {
        this.showdtCapacityKVAOthers = false;
        //  this.othersDtCapacityKVA=null;
      }
      this.getDTUpgradationCostMappings();
    },
    onSecondaryVoltageChange() {
      this.getDTUpgradationCostMappings();
      this.getSubstationUpgradationCostMappings();
    },
    fillLoadProfileData(profile) {
      this.projectData.pincode = profile.pincode;
      this.projectData.stateName = profile.stateName;
      this.projectData.loadProfileYear = profile.profileYear;
      this.projectData.feederLengthKm = profile.feederLengthKm;
      this.profileType = profile.profileType;
      this.projectData.feederType = profile.feederType;

      this.projectData.loadProfileTitle =
        profile.loadProfileTitle !== null ? profile.loadProfileTitle : "";
      this.projectData.stateLevelLoadProfileTitle =
        profile.stateLevelLoadProfileTitle
          ? profile.stateLevelLoadProfileTitle
          : "";
      if (profile.profileType === "dt") {
        this.projectData.substationName = profile.substationName;
        this.projectData.dtName = profile.dtName;
        this.projectData.powerFactor = profile.powerFactor;
        this.projectData.dtTapping = profile.dtTapping;
        this.projectData.primaryVoltage = profile.primaryVoltage;

        this.projectData.dtCapacityKVA = profile.dtCapacityKVA;

        this.projectData.secondaryVoltage = profile.secondaryVoltage;
        this.getDTUpgradationCostMappings();
      }
      if (profile.profileType === "substation") {
        this.projectData.powerFactor = profile.powerFactor;
        this.projectData.totalCapacityMVA = profile.totalCapacityMVA;
        this.projectData.incomingFeederVoltageKV =
          profile.incomingFeederVoltageKV;
        this.projectData.outgoingFeederVoltageKV =
          profile.outgoingFeederVoltageKV;
        this.getSubstationUpgradationCostMappings();
      }
      if (profile.profileType === "feeder") {
        this.projectData.sanctionedLoadMW = profile.sanctionedLoadMW;
        this.projectData.feederName = profile.feederName;
        this.projectData.feederVoltageKV = profile.feederVoltageKV;

        this.getFeederUpgradationCostMappings();
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    tabOne() {
      if (!this.isFormValidate()) {
        return;
      } else {
        if (
          this.oldProjectTitle !== this.projectData.title ||
          this.oldProjectTechnologyType !== this.projectData.technologyType
        ) {
          this.submit(true);
          this.oldProjectTitle = this.projectData.title;
          this.oldProjectTechnologyType = this.projectData.technologyType;
        }
        this.e1 = 2;
        this.fillPrimarVoltage();
      }
    },
    tabTwo() {
      if (!this.isFormValidate()) {
        return;
      } else {
        this.fillCostInLakhs();
        if (this.ProjectData.isCloned) {
          this.confirmationDialogProps.onClose = this.changeConfirm;
          this.confirmationDialogProps.title = "BAU analysis begins";
          this.confirmationDialogProps.message =
            "Feeder data cannot be modified once BAU analysis begins. Do you want to proceed?";
          this.confirmationDialogProps.negativeActionText =
            "Save, do not run analysis";
          this.confirmationDialogProps.isVisible = true;
          this.confirmationDialogProps = { ...this.confirmationDialogProps };
        }
        if (!this.ProjectData.isCloned) {
          this.e1 = 3;
        }
      }
      
    },
    tabThree() {},
    tabFour() {
      if (!this.isFormValidate()) {
        return;
      } else {
        this.e1 = 4;
      }
    },
    onPincodeChange() {
      if (this.projectData.pincode.length >= 6) {
        this.getStateName();
      } else {
        this.projectData.stateName = "";
      }
    },
    getDTUpgradationCostMappings() {
      if (this.analysislevel !== "dt") return;
      if (
        this.analysislevel &&
        this.feederData.primaryVoltage &&
        this.feederData.dtCapacityKVA
      ) {
        const costMaping = this.upgradationCostMappingDetails.find(
          (f) =>
            f.analysisLevel == this.analysislevel &&
            f.voltageLevelsKV == this.feederData.primaryVoltage &&
            f.dtCapacityKVA == this.feederData.dtCapacityKVA
        );
        this.fillUpgradationDetails(costMaping);
      }
    },
    fillUpgradationDetails(costMaping) {
      if (costMaping) {
        this.projectData.costInLakhs = costMaping.costInLakhs;
      }
      // else {
      //   this.cleareUpgradationDetails();
      // }
    },
    async getStateName() {
      this.projectData.stateName = PincodeService.methods.getStateName(
        this.projectData.pincode
      );
    },
    async getConductorTypeDetails() {
      const res = await DataList.methods.fetchData("conductorType");
      this.conductortypeDetails = res;
    },
    async getSubstationProfileFileList() {
      const res = await DataList.methods.fetchData("substationProfileFileList");
      this.substationProfileFileList = res;
    },
    async getHTProfileFileList() {
      const res = await DataList.methods.fetchData("htProfileFileList");
      this.htProfileFileList = res;
    },
    async getDTProfileFileList() {
      const res = await DataList.methods.fetchData("dtProfileFileList");
      this.dtProfileFileList = res;
    },
    selectMarginalCostItem(item) {
      this.marginalCostOfReplacedEnergyMetricType = item;
    },
    fillExistinfProfiles() {
      this.dbFileEntity = this.loadProfilesAll.filter(
        (profile) => profile.profileType === this.projectData.analysisLevel
      );
    },
    onChangeAnalysisLevel() {
      this.dbFileEntity = this.loadProfilesAll.filter(
        (profile) => profile.profileType === this.projectData.analysisLevel
      );
    },
    fillCostUpgradationtoolTip() {
      const _costOfUpgradationTootip = TooltipsData.methods.getTooltips(
        "costOfUpgradationTootip"
      );
      this.costOfUpgradationTootip = _costOfUpgradationTootip.find(
        (d) => d.key === this.analysislevel
      ).value;
    },
    setLoadProfile(project) {
      if (project.loadProfileId) {
        this.projectData.loadProfileId = project.loadProfileId;
      }
      if (project.loadProfileFile) {
        this.isOpenProfileDivision = true;
        this.profileSelection = "NA";
        this.projectData.LoadProfileFile = project.loadProfileFile.name;
        this.projectData.loadProfileTitle =
          project.loadProfileTitle !== "null" &&
          project.loadProfileTitle !== null
            ? project.loadProfileTitle
            : "";
        this.projectData.feederDataCsvFile = project.loadProfileFile;
        this.projectData.loadProfileYear = project.loadProfileYear;
      }
    },
    setStateLevelProfile(project) {
      if (typeof project.feederData.stateLevelProfile === "undefined") {
        this.projectData.stateLevelLoadProfileFile =
          project.stateLevelLoadProfileFile;
        this.projectData.stateLevelLoadProfileTitle =
          project.stateLevelLoadProfileTitle;
        this.projectData.stateLevelCsvFile = project.stateLevelLoadProfileFile;

        if (project.stateLevelLoadProfileFile) {
          this.projectData.isStateLevelFileExist = true;
        }
      }

      if (typeof project.feederData.stateLevelProfile !== "undefined") {
        if (
          typeof project.feederData.stateLevelProfile.profileId !== "undefined"
        ) {
          this.projectData.profileId =
            project.feederData.stateLevelProfile.profileId;
        } else {
          this.projectData.peakLoadEventTime = displayDateTime(
            project.feederData.stateLevelProfile.peakLoadEventTime
          );
          this.projectData.peakLoadDemandMW =
            project.feederData.stateLevelProfile.peakLoadDemandMW;
        }
      }
    },
    setMarginalCostData(project) {
      this.projectData.marginalCostOfReplacedEnergyMetricType =
        project.marginalCostOfReplacedEnergyMetricType;
      this.marginalCostOfReplacedEnergyMetricType =
        project.marginalCostOfReplacedEnergyMetricType;

      if (
        this.projectData.marginalCostOfReplacedEnergyMetricType ===
        "marginal_cost_of_generator_to_be_replaced"
      ) {
        this.projectData.marginalCostOfReplacedEnergyMetricData =
          project.marginalCostOfReplacedEnergyMetricData;
      }
      if (
        this.projectData.marginalCostOfReplacedEnergyMetricType ===
          "cost_as_per_iex_data" ||
        this.projectData.marginalCostOfReplacedEnergyMetricType ===
          "hourly_cost_of_supply_for_one_year"
      ) {
        this.projectData.marginalCostOfReplacedEnergyMetricData =
          project.marginalCostOfReplacedEnergyMetricFile.name;
        this.projectData.marginalCostOfReplacedEnergyMetricDataFile =
          project.marginalCostOfReplacedEnergyMetricFile;
      }
      if (
        this.projectData.marginalCostOfReplacedEnergyMetricType === "database"
      ) {
        this.projectData.marginalCostOfReplacedEnergyMetricData =
          project.marginalCostOfReplacedEnergyMetricRecord;
      }
    },
    setTechnologyData(project) {
      if (project.technologyType === "solar") {
        if (project.technologyData) {
          this.projectData.solarCapacity = project.technologyData.solarCapacity;
          this.projectData.interconnectionLocationSolar =
            project.technologyData.interconnectionLocationSolar;
        }
      }

      if (project.technologyType === "storage") {
        if (project.technologyData) {
          this.projectData.inverterCapacityForStorage =
            project.technologyData.inverterCapacityForStorage;
          this.projectData.interconnectionLocationStorage =
            project.technologyData.interconnectionLocationStorage;
          this.projectData.storageCapacity =
            project.technologyData.storageCapacity;
          this.projectData.storageChargingDischargingStrategy =
            project.technologyData.storageChargingDischargingStrategy;
        }
      }
      if (project.technologyType === "solar_plus_storage") {
        if (project.technologyData) {
          this.projectData.inverterCapacityForStorage =
            project.technologyData.inverterCapacityForStorage;
          this.projectData.interconnectionLocationStorage =
            project.technologyData.interconnectionLocationStorage;
          this.projectData.storageCapacity =
            project.technologyData.storageCapacity;
          this.projectData.solarCapacity = project.technologyData.solarCapacity;
          this.projectData.interconnectionLocationSolar =
            project.technologyData.interconnectionLocationSolar;
          this.projectData.storageChargingDischargingStrategy =
            project.technologyData.storageChargingDischargingStrategy;
        }
      }
    },
    setFeederData(project) {
      this.status = project.status;
      this.projectData._id = project._id;
      this.projectData.analysisLevel = project.analysisLevel;
      this.projectData.technologyType = project.technologyType;
      this.projectData.title = project.title;
      this.projectData.loadProfileYear = project.loadProfileYear;
      this.projectData.substationName = project.feederData.substationName;
      this.projectData.dtName = project.feederData.dtName;
      this.projectData.feederName = project.feederData.feederName;
      this.projectData.totalCapacityMVA = project.feederData.totalCapacityMVA;
      this.projectData.feederCount = project.feederData.feederCount;
      this.projectData.incomingFeederVoltageKV =
        project.feederData.incomingFeederVoltageKV;
      this.projectData.outgoingFeederVoltageKV =
        project.feederData.outgoingFeederVoltageKV;
      this.projectData.pincode = project.feederData.pincode;
      this.projectData.stateName = project.feederData.stateName;
      this.projectData.feederType = project.feederData.feederType;
      this.projectData.feederVoltageKV = project.feederData.feederVoltageKV;
      this.projectData.sanctionedLoadMW = project.feederData.sanctionedLoadMW;
      this.projectData.powerFactor = project.feederData.powerFactor;
      this.projectData.dtTapping = project.feederData.dtTapping;
      this.projectData.stateLevelDistributedSolarEnergyCapacityAddition=project.stateLevelDistributedSolarEnergyCapacityAddition;
      // console.log('dt capacity',  project.feederData.dtCapacityKVA);

      const index = this.dtCapacityKVAs.findIndex(
        (item) => item === project.feederData.dtCapacityKVA
      );
      if (index < 0) {
        this.projectData.dtCapacityKVA = "others";
        this.showdtCapacityKVAOthers = true;
        this.othersDtCapacityKVA = project.feederData.dtCapacityKVA;
      } else {
        this.showdtCapacityKVAOthers = false;
        this.projectData.dtCapacityKVA = project.feederData.dtCapacityKVA;
      }
      // console.log(index);
      // console.log(fruits[index]); // blueberries

      this.projectData.primaryVoltage = project.feederData.primaryVoltage;
      this.projectData.secondaryVoltage = project.feederData.secondaryVoltage;
      this.projectData.feederLengthKm = project.feederData.feederLengthKm;
      this.projectData.profileType = project.feederData.profileType;

      // analysisPeriod,capacityUpgradationUpperLimit,loadShiftedAfterUpgradation shifted from voder to feeder

      this.projectData.analysisPeriod = project.feederData.analysisPeriod;
      this.projectData.capacityUpgradationUpperLimit =
        project.feederData.capacityUpgradationUpperLimit;
      this.projectData.loadShiftedAfterUpgradation =
        project.feederData.loadShiftedAfterUpgradation;
      this.projectData.yearlyChangeInLoadPercent =
        project.feederData.yearlyChangeInLoadPercent;
      this.projectData.conductorTypeTitle =
        project.feederData.conductorType.title;
      this.projectData.resistanceOhmsPerKm =
        project.feederData.conductorType.resistanceOhmsPerKm;
      this.projectData.reactanceOhmsPerKm =
        project.feederData.conductorType.reactanceOhmsPerKm;

      this.projectData.peakCurrentCarryingCapacityAmps =
        project.feederData.conductorType.peakCurrentCarryingCapacityAmps;
    },

    async fillCostInLakhs() {
      if (this.projectData.analysisLevel === "feeder") {
        if (
          this.projectData.analysisLevel &&
          this.projectData.feederVoltageKV &&
          this.projectData.feederType
        ) {
          const costMaping = this.upgradationCostMappingDetails.find(
            (f) =>
              f.analysisLevel === this.projectData.analysisLevel &&
              f.feederType === this.projectData.feederType &&
              f.voltageLevelsKV == this.projectData.feederVoltageKV
          );
          if (costMaping) {
            this.projectData.costInLakhs = costMaping.costInLakhs;
          }
        }
      }
      if (this.projectData.analysisLevel === "substation") {
        if (
          this.projectData.analysisLevel &&
          this.projectData.outgoingFeederVoltageKV
        ) {
          const costMaping = this.upgradationCostMappingDetails.find(
            (cm) => cm.analysisLevel === this.projectData.analysisLevel
          );
          this.projectData.costInLakhs = costMaping.costInLakhs;
        }
      }

      if (this.projectData.analysisLevel === "dt") {
        if (
          this.projectData.analysisLevel &&
          this.projectData.primaryVoltage &&
          this.projectData.dtCapacityKVA
        ) {
          const costMaping = this.upgradationCostMappingDetails.find(
            (f) =>
              f.analysisLevel == this.projectData.analysisLevel &&
              f.voltageLevelsKV == this.projectData.primaryVoltage &&
              f.dtCapacityKVA == this.projectData.dtCapacityKVA
          );
          this.projectData.costInLakhs = costMaping.costInLakhs;
        }
      }
    },
    async fillMasterConstent() {
      const masterConstants =
        await AdminFeederStore.methods.getAllMasterConstant();
      this.masterConstants = masterConstants[masterConstants.length - 1];
      this.projectData.transmissionCapacityCost =
        this.masterConstants.transmissionCapacityCostINR_MW;
      this.projectData.generationCapacityCost =
        this.masterConstants.generationCapacityCostINR_MW;
      this.projectData.discountFactor = this.masterConstants.discountFactor;
      this.projectData.emissionCostCo2 =
        this.masterConstants.emissionCosts.emissionCostCo2;
      this.projectData.emissionCostNo2 =
        this.masterConstants.emissionCosts.emissionCostNo2;
      this.projectData.emissionCostSo2 =
        this.masterConstants.emissionCosts.emissionCostSo2;
      this.projectData.emissionCostSPM2_5 =
        this.masterConstants.emissionCosts.emissionCostSPM2_5;
    },
    async setVoderData(project) {
      // const masterConstants =
      //   await AdminFeederStore.methods.getAllMasterConstant();
      // this.masterConstants = masterConstants[masterConstants.length - 1];

      if (project.voderData) {
        if (typeof project.voderData.avgTransmissionLosses !== "undefined") {
          this.projectData.avgTransmissionLosses =
            project.voderData.avgTransmissionLosses;
        }

        if (typeof project.voderData.transmissionCapacityCost !== "undefined") {
          this.projectData.transmissionCapacityCost =
            project.voderData.transmissionCapacityCost;
        }

        if (typeof project.voderData.generationCapacityCost !== "undefined") {
          this.projectData.generationCapacityCost =
            project.voderData.generationCapacityCost;
        }

        if (typeof project.voderData.discountFactor !== "undefined") {
          this.projectData.discountFactor = project.voderData.discountFactor;
        }

        if (typeof project.voderData.interestRate !== "undefined") {
          this.projectData.interestRate = project.voderData.interestRate;
        } else {
          this.projectData.interestRate = 6.5;
        }

        if (
          typeof project.voderData.upgradationCost.voltageLevelsKV !==
          "undefined"
        ) {
          this.projectData.voltageLevelsKV =
            project.voderData.upgradationCost.voltageLevelsKV;
        }
        if (
          typeof project.voderData.upgradationCost.costInLakhs !== "undefined"
        ) {
          this.projectData.costInLakhs =
            project.voderData.upgradationCost.costInLakhs;
        }
        if (
          typeof project.voderData.upgradationCost.emissionCostCo2 ===
          "undefined"
        ) {
          this.projectData.emissionCostCo2 =
            project.voderData.emissionCosts.emissionCostCo2;
        }

        if (
          typeof project.voderData.upgradationCost.emissionCostNo2 ===
          "undefined"
        ) {
          this.projectData.emissionCostNo2 =
            project.voderData.emissionCosts.emissionCostNo2;
        }
        if (
          typeof project.voderData.upgradationCost.emissionCostSo2 ===
          "undefined"
        ) {
          this.projectData.emissionCostSo2 =
            project.voderData.emissionCosts.emissionCostSo2;
        }

        if (
          typeof project.voderData.upgradationCost.emissionCostSPM2_5 ===
          "undefined"
        ) {
          this.projectData.emissionCostSPM2_5 =
            project.voderData.emissionCosts.emissionCostSPM2_5;
        }
      } else {
        if (this.projectData.analysisLevel === "feeder") {
          if (
            this.projectData.analysisLevel &&
            this.projectData.feederVoltageKV &&
            this.projectData.feederType
          ) {
            const costMaping = this.upgradationCostMappingDetails.find(
              (f) =>
                f.analysisLevel === this.projectData.analysisLevel &&
                f.feederType === this.projectData.feederType &&
                f.voltageLevelsKV == this.projectData.feederVoltageKV
            );
            if (costMaping) {
              this.projectData.costInLakhs = costMaping.costInLakhs;
            }
          }
        }

        if (this.projectData.analysisLevel === "substation") {
          if (this.analysisLevel && this.projectData.outgoingFeederVoltageKV) {
            const costMaping = this.upgradationCostMappingDetails.find(
              (cm) => cm.analysisLevel === this.projectData.analysislevel
            );
            this.projectData.costInLakhs = costMaping.costInLakhs;
          }
        }

        if (this.projectData.analysisLevel === "dt") {
          if (
            this.projectData.analysisLevel &&
            this.projectData.primaryVoltage &&
            this.projectData.dtCapacityKVA
          ) {
            const costMaping = this.upgradationCostMappingDetails.find(
              (f) =>
                f.analysisLevel == this.projectData.analysisLevel &&
                f.voltageLevelsKV == this.projectData.primaryVoltage &&
                f.dtCapacityKVA == this.projectData.dtCapacityKVA
            );
            this.projectData.costInLakhs = costMaping.costInLakhs;
          }
        }
        // this.projectData.intrestrate =  this.masterConstants.intrestRate
        // console.log('intrestrate',this.masterConstants)
      }
    },

    async getAllupgradationCostMappings() {
      return await DataList.methods
        .fetchData("upgradationCostMappings")
        .then((res) => {
          return res;
        });
      // this.upgradationCostMappingDetails = res;
    },

    getClonedProjectPayload(projectData, voltageLevelsKV) {
      const payload = {
        status: projectStatus.ANALYSIS_READY_BAU,
        title: projectData.title,
        technologyType: projectData.technologyType,
        // feederDtName: projectData.feederDtName,
        isCloned: false,
        analysisLevel: projectData.analysisLevel,
        substationName: projectData.substationName,
        feederName: this.projectData.feederName,
        stateLevelDistributedSolarEnergyCapacityAddition: projectData.stateLevelDistributedSolarEnergyCapacityAddition,
       feederData: {
          profileId: projectData.loadProfileId,
          title: projectData.loadProfileTitle,
          csvFile:
            projectData.feederDataCsvFile && this.isChangedFeederProfileCSV
              ? projectData.feederDataCsvFile
              : null,
          profileType: projectData.analysisLevel,
          feederName: this.projectData.feederName,
          dtName: projectData.dtName,
          pincode: projectData.pincode,
          stateName: projectData.stateName,
          feederType: projectData.feederType,
          loadProfileYear:projectData.profileYear,
          feederLengthKm: projectData.feederLengthKm
            ? projectData.feederLengthKm
            : null,
          feederVoltageKV: projectData.feederVoltageKV
            ? projectData.feederVoltageKV
            : null,
          sanctionedLoadMW: projectData.sanctionedLoadMW
            ? projectData.sanctionedLoadMW
            : null,
          yearlyChangeInLoadPercent: projectData.yearlyChangeInLoadPercent
            ? projectData.yearlyChangeInLoadPercent
            : null,
          powerFactor: projectData.powerFactor ? projectData.powerFactor : null,
          dtTapping: projectData.dtTapping ? projectData.dtTapping : 0,

          // dtCapacityKVA: projectData.dtCapacityKVA
          //   ? projectData.dtCapacityKVA
          //   : null,
          dtCapacityKVA: this.showdtCapacityKVAOthers
            ? this.othersDtCapacityKVA
            : projectData.dtCapacityKVA
            ? projectData.dtCapacityKVA
            : null,

          primaryVoltage: projectData.primaryVoltage
            ? projectData.primaryVoltage
            : null,
          secondaryVoltage: projectData.secondaryVoltage
            ? projectData.secondaryVoltage
            : null,
          incomingFeederVoltageKV: projectData.incomingFeederVoltageKV
            ? projectData.incomingFeederVoltageKV
            : null,
          outgoingFeederVoltageKV: projectData.outgoingFeederVoltageKV
            ? projectData.outgoingFeederVoltageKV
            : null,
          totalCapacityMVA: projectData.totalCapacityMVA
            ? projectData.totalCapacityMVA
            : null,
          feederCount: projectData.feederCount ? projectData.feederCount : null,
          analysisPeriod: projectData.analysisPeriod
            ? projectData.analysisPeriod
            : null,
          capacityUpgradationUpperLimit:
            projectData.capacityUpgradationUpperLimit
              ? projectData.capacityUpgradationUpperLimit
              : null,
          loadShiftedAfterUpgradation: projectData.loadShiftedAfterUpgradation,
          stateLevelProfile: {
            profileId: projectData.profileId ? projectData.profileId : null,
            title: projectData.stateLevelLoadProfileTitle
              ? projectData.stateLevelLoadProfileTitle
              : null,
            peakLoadDemandMW: projectData.peakLoadDemandMW
              ? projectData.peakLoadDemandMW
              : null,
            peakLoadEventTime: formatInputDate(projectData.peakLoadEventTime)
              ? formatInputDate(projectData.peakLoadEventTime)
              : null,
            csvFile:
              projectData.stateLevelCsvFile && this.isChangedStateProfileCSV
                ? projectData.stateLevelCsvFile
                : null,
          },
          conductorType: {
            title: projectData.conductorTypeTitle,
            reactanceOhmsPerKm: projectData.reactanceOhmsPerKm,
            resistanceOhmsPerKm: projectData.resistanceOhmsPerKm,
            peakCurrentCarryingCapacityAmps:
              projectData.peakCurrentCarryingCapacityAmps,
          },
        },
        technologyData: {
          solarCapacity: projectData.solarCapacity
            ? projectData.solarCapacity
            : null,
          interconnectionLocationSolar: projectData.interconnectionLocationSolar
            ? projectData.interconnectionLocationSolar
            : null,
          inverterCapacityForStorage: projectData.inverterCapacityForStorage
            ? projectData.inverterCapacityForStorage
            : null,
          storageCapacity: projectData.storageCapacity
            ? projectData.storageCapacity
            : null,
          interconnectionLocationStorage:
            projectData.interconnectionLocationStorage
              ? projectData.interconnectionLocationStorage
              : null,
          storageChargingDischargingStrategy:
            projectData.storageChargingDischargingStrategy
              ? projectData.storageChargingDischargingStrategy
              : null,
        },
        voderData: {
          marginalCostOfReplacedEnergyMetricType:
            projectData.marginalCostOfReplacedEnergyMetricType
              ? projectData.marginalCostOfReplacedEnergyMetricType
              : null,
          marginalCostOfReplacedEnergyMetricData:
            projectData.marginalCostOfReplacedEnergyMetricData
              ? projectData.marginalCostOfReplacedEnergyMetricData
              : null,
          csvFile:
            projectData.marginalCostOfReplacedEnergyMetricDataFile &&
            this.isChangedMarginalCSV
              ? projectData.marginalCostOfReplacedEnergyMetricDataFile
              : null,
          analysisPeriod: projectData.analysisPerio
            ? projectData.analysisPerio
            : null,
          avgTransmissionLosses: projectData.avgTransmissionLosses
            ? projectData.avgTransmissionLosses
            : null,
          capacityUpgradationUpperLimit:
            projectData.capacityUpgradationUpperLimit
              ? projectData.capacityUpgradationUpperLimit
              : null,
          loadShiftedAfterUpgradation: projectData.loadShiftedAfterUpgradation
            ? projectData.loadShiftedAfterUpgradation
            : null,
          transmissionCapacityCost: projectData.transmissionCapacityCost
            ? projectData.transmissionCapacityCost
            : null,
          generationCapacityCost: projectData.generationCapacityCost
            ? projectData.generationCapacityCost
            : null,
          discountFactor: projectData.discountFactor
            ? projectData.discountFactor
            : null,
          interestRate: projectData.interestRate
            ? projectData.interestRate
            : null,

          upgradationCost: {
            analysisLevel: projectData.analysisLevel,
            voltageLevelsKV: voltageLevelsKV,
            feederType: projectData.feederType,
            costInLakhs: projectData.costInLakhs,
          },
          emissionCosts: {
            emissionCostCo2: projectData.emissionCostCo2,
            emissionCostSo2: projectData.emissionCostSo2,
            emissionCostNo2: projectData.emissionCostNo2,
            emissionCostSPM2_5: projectData.emissionCostSPM2_5,
          },
        },
      };
      return payload;
    },

    fillToolTips() {
      this.substationProfileTooltip =
        TooltipsData.methods.getTooltips("nameOfSubstation");
      this.htLoadProfileTooltip = TooltipsData.methods.getTooltips("htFeeder");
      this.dtLoadProfileTooltip =
        TooltipsData.methods.getTooltips("dtLoadProfile");
      this.pincodeTooltip = TooltipsData.methods.getTooltips("pincode");
      this.feederLengthTooltip =
        TooltipsData.methods.getTooltips("feederLength");
      this.sanctionedTooltip = TooltipsData.methods.getTooltips("sanctioned");
      this.stateLevelTooltip = TooltipsData.methods.getTooltips("stateLevel");
      this.yearlyChangeInLoadTooltip =
        TooltipsData.methods.getTooltips("yearlyChangeInLoad");
      this.typeOfConductorTooltip =
        TooltipsData.methods.getTooltips("typeOfConductor");
      this.marginalCostOfEnergyTooltip = TooltipsData.methods.getTooltips(
        "marginalCostOfEnergy"
      );
      this.interconnectionLocationStorageTooltip =
        TooltipsData.methods.getTooltips("interconnectionLocationStorage");
      this.stateLevelLoadTooltip =
        TooltipsData.methods.getTooltips("stateLevelLoad");
      this.upperLimitForCapacityUpgradation = TooltipsData.methods.getTooltips(
        "upperLimitForCapacityUpgradation"
      );
      this.percentageOfLadShiftedAfterUpgradationTooltip =
        TooltipsData.methods.getTooltips(
          "percentageOfLadShiftedAfterUpgradation"
        );
      this.transmissionCapacityCostTooltip = TooltipsData.methods.getTooltips(
        "transmissionCapacityCost"
      );
      this.generationCapacityCostTooltip = TooltipsData.methods.getTooltips(
        "generationCapacityCost"
      );
      this.stateLevelDistributedSolarEnergyCapacityAdditionTooltip =
        TooltipsData.methods.getTooltips(
          "stateLevelDistributedSolarEnergyCapacityAddition"
        );
    },
    onChangeConductorTypes() {
      const e = this.projectData.conductorTypeTitle;
      if (e === "Others") {
        this.resistanceOhmsPerKm = "";
        this.reactanceOhmsPerKm = "";
        this.peakCurrentCarryingCapacityAmps = "";
        return;
      }
      const conductorTypeDetails = this.conductorTypes.find(
        (x) => x.title === e
      );
      this.resistanceOhmsPerKm = conductorTypeDetails.resistanceOhmsPerKm;
      this.reactanceOhmsPerKm = conductorTypeDetails.reactanceOhmsPerKm;
      this.peakCurrentCarryingCapacityAmps =
        conductorTypeDetails.peakCurrentCarryingCapacityAmps;
    },
    async FillData() {
      const project = { ...this.ProjectData };
      this.oldProjectTitle = project.title;
      this.oldProjectTechnologyType = project.technologyType;
      this.dbFileEntity = this.loadProfilesAll.filter(
        (profile) => profile.profileType === project.analysisLevel
      );

      if (typeof this.ProjectData.isCloned === "undefined") {
        this.ProjectData.isCloned = false;
      }

      if (project.isCloned && project.isCloned === true) {
        this.tempLoadProfileId = this.projectData.loadProfileId;
        this.isLoadProfileReadOnly = false;
        this.isStateLevelProfileReadOnly = false;
      }
      this.fillMasterConstent();
      if (project.feederData) {
        this.setFeederData(project);
        this.setLoadProfile(project);
      }
      if (project.feederData.stateLevelProfile) {
        this.setStateLevelProfile(project);
      }

      this.setVoderData(project);

      if (project.technologyType) {
        this.setTechnologyData(project);
      }
      if (project.marginalCostOfReplacedEnergyMetricType) {
        this.setMarginalCostData(project);
      }
    },

    // setval(e) {
    //   if (e.datasource === "analysisLevels/active") {
    //     this.analysislevel = e.value;
    //     this.dbFileEntity = this.loadProfilesAll.filter(
    //       (profile) => profile.profileType === e.value
    //     );
    //   }
    //   if (e.datasource === "technologyTypes/active") {
    //     this.technologyType = e.value;
    //   }
    //   if (e.datasource === "feederTypes") {
    //     this.feederType = e.value;
    //     this.getFeederUpgradationCostMappings();
    //   }
    //   if (e.datasource === "feederVoltageKV") {
    //     this.feederVoltageKV = e.value;
    //     this.getFeederUpgradationCostMappings();
    //     this.getDTUpgradationCostMappings();
    //   }
    //   if (e.datasource === "conductorTypes/published") {
    //     this.conductortype = e.value;
    //     if (e.value === "Others") {
    //       this.resistanceOhmsPerKm = "";
    //       this.reactanceOhmsPerKm = "";
    //       this.peakCurrentCarryingCapacityAmps = "";
    //       return;
    //     }
    //     const conductorTypeDetails = e.Items.find((x) => x.title === e.value);
    //     this.resistanceOhmsPerKm = conductorTypeDetails.resistanceOhmsPerKm;
    //     this.reactanceOhmsPerKm = conductorTypeDetails.reactanceOhmsPerKm;
    //     this.peakCurrentCarryingCapacityAmps =
    //       conductorTypeDetails.peakCurrentCarryingCapacityAmps;
    //   }
    //   if (e.datasource === "marginalCostOfReplacedEnergyRecords/published") {
    //     this.marginalCostOfReplacedEnergyMetricData = e.Items;
    //   }
    //   if (e.datasource === "solarInterconnectionLocations") {
    //     this.projectData.interconnectionLocationSolar = e.value;
    //   }
    //   if (e.datasource === "Interconnectionlocationstorage") {
    //     this.interconnectionLocationStorage = e.value;
    //   }
    //   if (e.datasource === "chargingdischarging") {
    //     this.storagechargingdischargingstrategy = e.value;
    //   }
    //   if (e.datasource === "FeederLoadProfile") {
    //     this.FeederLoadProfiles = e.value;
    //   }
    //   if (e.datasource === "Statelevelloadprofile") {
    //     this.Statelevelloadprofile = e.value;
    //   }
    //   if (e.datasource === "Projects") {
    //     this.projectname = e.value;
    //   }
    // },

    isFormValidate() {
      if (this.e1 === 1) {
        this.status = "inputs_required";

        if (!this.$refs.formProject.validate()) {
          return false;
        } else {
          return true;
        }
      }
      if (this.e1 === 2) {
        this.status = "analysis_ready_bau";
        if (
          !this.$refs.formProfile.validate() ||
          !this.$refs.formStateProfile.validate() ||
          !this.$refs.formProfileAdvance.validate()
        ) {
          return false;
        } else {
          return true;
        }
      }

      if (this.e1 === 3) {
        this.status = "analysis_ready_bau";
        if (!this.$refs.formTechnology.validate()) {
          return false;
        } else {
          return true;
        }
      }
      if (this.e1 === 4) {
        this.status = "analysis_ready_der";
        if (!this.$refs.formVoder.validate()) {
          return false;
        } else {
          return true;
        }
      }
    },

    showFinalMessage() {
      if (this.e1 === 4) {
        // this.isSowfinalMessage = true;
        this.showRunAnalysisDialog();
      }
    },

    submit(isProjectTitleUpdate) {
      if (!this.isFormValidate()) {
        return;
      }
      this.projectData.peakLoadEventTime = formatInputDate(
        this.projectData.peakLoadEventTime
      );
      let voltageLevelsKV = null;
      if (this.projectData.analysisLevel === "dt") {
        voltageLevelsKV = this.projectData.primaryVoltage;
      } else if (this.projectData.analysisLevel === "feeder") {
        voltageLevelsKV = this.projectData.feederVoltageKV;
      } else if (this.projectData.analysisLevel === "substation") {
        voltageLevelsKV = this.projectData.outgoingFeederVoltageKV;
      }

      // this.projectData.status = this.status;
      // this.loading = true;

      if (this.EditMode === true) {
        let payload = {};
        let entityName = "";

        if (this.e1 === 3) {
          entityName = "Project-Technology Data";
          payload = {
            solarCapacity: this.projectData.solarCapacity,
            interconnectionLocationSolar:
              this.projectData.interconnectionLocationSolar,
            inverterCapacityForStorage:
              this.projectData.inverterCapacityForStorage,
            storageCapacity: this.projectData.storageCapacity,
            interconnectionLocationStorage:
              this.projectData.interconnectionLocationStorage,
            storageChargingDischargingStrategy:
              this.projectData.storageChargingDischargingStrategy,
          };
        }

        if (this.e1 === 4) {
          entityName = "Project-Voder Data";
          payload = {
            marginalCostOfReplacedEnergyMetricType:
              this.projectData.marginalCostOfReplacedEnergyMetricType,
            marginalCostOfReplacedEnergyMetricDataFile:
              this.projectData.marginalCostOfReplacedEnergyMetricDataFile,
            marginalCostOfReplacedEnergyMetricData:
              this.projectData.marginalCostOfReplacedEnergyMetricData,

            avgTransmissionLosses: this.projectData.avgTransmissionLosses,
            transmissionCapacityCost: this.projectData.transmissionCapacityCost,
            generationCapacityCost: this.projectData.generationCapacityCost,
            discountFactor: this.projectData.discountFactor,
            interestRate: this.projectData.interestRate,

            upgradationCost: {
              analysisLevel: this.projectData.analysisLevel,
              voltageLevelsKV: voltageLevelsKV,
              feederType: this.projectData.feederType,
              costInLakhs: this.projectData.costInLakhs,
            },
            emissionCosts: {
              emissionCostCo2: this.projectData.emissionCostCo2,
              emissionCostSo2: this.projectData.emissionCostSo2,
              emissionCostNo2: this.projectData.emissionCostNo2,
              emissionCostSPM2_5: this.projectData.emissionCostSPM2_5,
            },
          };
        }

        if (this.e1 === 2 && this.ProjectData.isCloned) {
          this.projectData.isCloned = false;
          payload = this.getClonedProjectPayload(
            this.projectData,
            voltageLevelsKV
          );
          ProjectService.updateClonedProjectTechnologyVoder(
            this.projectData._id,
            payload
          )
            .then(() => {
              bus.$emit("updateNotification", "OK", "", entityName);
              this.showFinalMessage();
              this.isLoadProfileReadOnly = true;
              this.ProjectData.isCloned = false;
              this.loading = false;
              return;
            })
            .catch((error) => {
              bus.$emit(
                "updateNotification",
                "400",
                error.response.data._issues
              );
            });
        }

        if (!isProjectTitleUpdate && !this.ProjectData.isCloned) {
          ProjectService.updateProjectTechnologyVoder(
            this.projectData._id,
            payload,
            this.status,
            this.e1
          )
            .then(() => {
              bus.$emit("updateNotification", "OK", "", entityName);
              this.showFinalMessage();
              if (this.e1 === 3) {
                this.e1 = 4;
              }
            })
            .catch((error) => {
              bus.$emit(
                "updateNotification",
                "400",
                error.response.data._issues
              );
            });
        }
        if (isProjectTitleUpdate) {
          ProjectService.updateProjectTitle(
            this.projectData._id,
            this.projectData.title,
            this.projectData.technologyType,
            this.status,
            this.e1
          )
            .then(() => {
              bus.$emit("updateNotification", "OK", "", entityName);
              if (this.e1 === 3) {
                this.e1 = 4;
              }
            })
            .catch((error) => {
              bus.$emit(
                "updateNotification",
                "400",
                error.response.data._issues
              );
            });
        }
      }
    },
  },
};
</script>